import { useQuery } from '@tanstack/react-query';
import { getBatchJobs, getBatchDetails, type BatchFilters } from '../services/dashboard-api';

/**
 * Hook to fetch all batch jobs with optional filtering
 */
export function useBatchJobs(options?: BatchFilters) {
  return useQuery({
    queryKey: ['batchJobs', options],
    queryFn: () => getBatchJobs(options),
    refetchInterval: 15000, // Refresh every 15 seconds
    staleTime: 5000, // Consider data stale after 5 seconds
  });
}

/**
 * Hook to fetch a single batch job with documents
 */
export function useBatchJob(batchId: string | null) {
  return useQuery({
    queryKey: ['batchJob', batchId],
    queryFn: () => (batchId ? getBatchDetails(batchId) : null),
    enabled: !!batchId,
    refetchInterval: 10000, // Refresh every 10 seconds
  });
}

/**
 * Hook to fetch documents for a specific batch
 * (documents are included in getBatchDetails)
 */
export function useBatchDocuments(batchId: string | null) {
  const { data } = useBatchJob(batchId);
  return {
    data: data?.documents || [],
    isLoading: !data,
  };
}
